var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerTaskNavIcn2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.83333H7.08333C6.39583 5.83333 5.83333 6.39583 5.83333 7.08333V7.5H2.91667C2.6875 7.5 2.5 7.3125 2.5 7.08333V4.16667H4.16667V1.25C4.16667 0.5625 3.60417 0 2.91667 0H1.25C0.5625 0 0 0.5625 0 1.25V4.16667H1.66667V7.08333C1.66667 7.77083 2.22917 8.33333 2.91667 8.33333H5.83333V10H10V7.08333C10 6.39583 9.4375 5.83333 8.75 5.83333ZM0.833333 1.25C0.833333 1.02083 1.02083 0.833333 1.25 0.833333H2.91667C3.14583 0.833333 3.33333 1.02083 3.33333 1.25V3.33333H0.833333V1.25ZM9.16667 9.16667H6.66667V7.08333C6.66667 6.85417 6.85417 6.66667 7.08333 6.66667H8.75C8.97917 6.66667 9.16667 6.85417 9.16667 7.08333V9.16667Z",
    fill: "#567A9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTaskNavIcn2);
export default __webpack_public_path__ + "static/media/customerTaskNavIcn2.7437461212cb5aa6cfa73a4ef0279db7.svg";
export { ForwardRef as ReactComponent };